import anchor from '../img/anchor.jpg';
import axiom from '../img/axiom.jpg';
import ball from '../img/ball.jpg';
import block from '../img/block.jpg';
import carbon from '../img/carbon.jpg';
import echo from '../img/echo.jpg';
import lifebuoy from '../img/lifebuoy.jpg';
import lifejacket from '../img/lifejacket.jpg';
import line from '../img/line.jpg';
import mooring from '../img/mooring.jpg';
import pes from '../img/pes.jpg';
import sonar from '../img/sonar.jpg';
import rope from '../img/rope.jpg';
import winch from '../img/winch.jpg';
import stopper from '../img/stopper.jpg';

export const data = [
    {
        id: 1,
        name: 'Block with Removable Ring / ball bearing',
        image: block,
        description: 'Excellent quality and a well-balanced price-performance ratio. Single-sheave block with removable ring.',
        price: '€22.65',
        category: 'deck',
        showMore: 'false'
    },

    {
        id: 2,
        name: 'Spliced Eye on 3-Strand Rope',
        image: rope,
        description: 'Spliced eye on 3-strand rope. Suits all mooring lines, anchor lines, rodes, safety lines etc. Rope ends clean whipped. Note: Please indicate the desired eye length at the end of the order in the "additional notes" field.',
        price: '€15.92',
        category: 'rigging',
        showMore: 'false'
    },

    {
        id: 3,
        name: 'Self-Tailing Winch XT16 / 1-speed',
        image: winch,
        description: 'The new self-tailing winches of the XT series impress with a completely new and modern design while maintaining the high quality and manufacturing accuracy the name antal stands for.',
        price: '€378.11',
        category: 'deck',
        showMore: 'false'
    },

    {
        id: 4,
        name: 'DYNAMIC COLOR',
        image: line,
        description: 'Easy-handling, abrasion resistant line with low stretch, premium Polyester cover and Dyneema® core. DYNAMIC COLOR is ideal for use as a high-end sheet, or low-stretch halyard by advanced cruising sailors.',
        price: '€1.64',
        category: 'rigging',
        showMore: 'false'
    },

    {
        id: 5,
        name: 'Carbon Dioxide / 5 kg / Fire Class B',
        image: carbon,
        description: 'Portable steel carbon dioxide extinguisher. Approved according to DIN EN 3 for fire class B. Carbon dioxide is a residue-free extinguishing agent which is not electrically conductive. This makes these fire extinguishers suitable for extinguishing electrical equipment, diesel and petrol fires',
        price: '€107.52',
        category: 'safety',
        showMore: 'false'
    },

    {
        id: 6,
        name: 'Mooring Spring',
        image: mooring,
        description: 'These mooring spring should not be missing at any dock mooring. It will absorb shocks and help eliminate sudden jerks caused by waves or swells when moored. Made of stainless steel, available in 2 sizes.',
        price: '€10.88',
        category: 'anchoring',
        showMore: 'false'
    },

    {
        id: 7,
        name: 'AXIOM+ 7 / Touch',
        image: axiom,
        description: 'The Raymarine AXIOM+ features a new and significantly brighter HydroTough™ display, more internal memory and a faster quad-core processor. Thanks to the new LightHouse Dartmouth OS, you can take advantage of day and night modes, as well as support for Raymarine LightHouse Charts.',
        price: '€731.05',
        category: 'navigation',
        showMore: 'false'
    },

    {
        id: 8,
        name: 'XD 220 Life Jacket / red/black',
        image: lifejacket,
        description: 'The XD 220 automatic life jacket from SEATEC combines excellent freedom of movement with superior wearing comfort thanks to its ergonomic fit. With 220 N, it provides sufficient buoyancy at all times, even when wearing heavy sailing clothing.',
        price: '€109.20',
        category: 'safety',
        showMore: 'false'
    },

    {
        id: 9,
        name: 'M-Anchor - Stainless Steel',
        image: anchor,
        description: 'High-grade stainless steel anchor (AISI 316). Ground and polished. High stability, cast as one single piece.',
        price: '€132.73',
        category: 'anchoring',
        showMore: 'false'
    },

    {
        id: 10,
        name: 'Element 7S / CHIRP Sonar Module',
        image: sonar,
        description: 'Smart 7" multifunction display with user-friendly interface, integrated GPS antenna and built-in CHIRP sonar module. A touch screen was deliberately omitted from this Raymarine plotter, as the classic button controls in connection with the Raymarine Lighthouse Sport operating system make for intuitive and precise control of the device, even at high speeds and strong seas. ',
        price: '€420.13',
        category: 'navigation',
        showMore: 'false'
    },

    {
        id: 11,
        name: 'Squareline-PES / white',
        image: pes,
        description: 'Squareline-PES is a convenient mooring and anchoring line and consists of an 8-plait square braid. Easy to splice and connect with a chain forerunner. Colour: white. Price per metre.',
        price: '€2.69',
        category: 'rigging',
        showMore: 'false'
    },

    {
        id: 12,
        name: 'Ball Fender / red',
        image: ball,
        description: 'Heavy-duty, inflatable ball fender and marking buoy with special reinforced heads and solid-eye rope holes. Suitable for pleasure craft and commercial use.',
        price: '€20.13',
        category: 'anchoring',
        showMore: 'false'
    },

    {
        id: 13,
        name: 'Lifebuoy / white',
        image: lifebuoy,
        description: 'Classic lifebuoy in white / red.',
        price: '€33.57',
        category: 'safety',
        showMore: 'false'
    },

    {
        id: 14,
        name: 'TARGET 2 Echo-Sounder',
        image: echo,
        description: 'NASA TARGET 2 echo sounder incl. sensor with a depth-measuring range of 0.8 m to 100 m, adjustable low and shallow water alarm and keel offset.',
        price: '€126.01',
        category: 'navigation',
        showMore: 'false'
    },

    {
        id: 15,
        name: 'Rope stop RC750/ 3 sections',
        image: stopper,
        description: `Rutgerson's Bavaria RC halyard stopper. Made from glass fiber reinforced plastic. A spare plastic lever is available as an option. Version: 3-section`,
        price: '€235.25',
        category: 'deck',
        showMore: 'false'
    },
]
